var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"playBox",staticClass:"video"},[_c('div',{staticClass:"playWnd",attrs:{"id":"playWnd"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }